<!-- 通用上传组件-->
<template>
  <div class="common-upload">
    <el-upload
      class="upload-demo"
      :action="action"
      :http-request="httpRequest"
      :on-success="uploadSuccess"
      :on-remove="removeFile"
      :list-type="picture"
      :accept="accept"
      :file-list="fileList"
      drag
    >
      <div class="upload-inner">
        <span class="ue-btn ue-btn-filling">{{ buttonText }}</span>
        <div slot="tip" class="el-upload__tip">{{ tips }}</div>
      </div>
    </el-upload>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { FileUpload } from "@/assets/js/common";
import SparkMD5 from "@/assets/js/spark-md5.min";
export default {
  name: "CommonUpload",
  data() {
    return {
      action: "https://ueclub.kingdee.com",
    };
  },
  props: {
    buttonText: {
      type: String,
      default: "上传封面",
    },
    tips: {
      type: String,
      default: "图片尺寸: 1070* 482像素",
    },
    picture: {
      type: String,
      default: "text",
    },
    fileList: {
      type: Array,
    },
    accept: {
      type: String,
    },
    type: {
      type: String,
    },
  },
  methods: {
    ...mapActions("post", ["queryUpload", "uploadFile"]),
    async httpRequest(config) {
      const file = config.file;
      let resultData = await this.uploadFile({
        file: file,
        onProgress: (progressEvent) => {
          return config.onProgress(progressEvent, file);
        },
      });
      config.onSuccess({ ...resultData}, file);
    },
    uploadSuccess(res) {
      this.$emit("getdata", res);
    },
    removeFile(file) {
      this.$emit("removefile", file.uid);
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.common-upload {
  .upload-demo {
    .upload-inner {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: space-evenly;
      padding: 0 44px;
    }
  }
  > .upcourse-button {
    > .up-button-content {
      width: 886px;
      height: 141px;
      background: rgba(248, 248, 248, 1);
      .el-button {
        width: 216px;
        height: 38px;
        background: rgba(231, 0, 18, 1);
        border-radius: 19px;
        border: 0px solid rgba(223, 224, 226, 1);
        padding: 5px 14px 6px 14px;
        margin: 32px 0 13px 0;
        > span {
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: rgba(255, 255, 255, 1);
          line-height: 19px;
        }
      }
      .el-upload__tip {
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: rgba(153, 153, 153, 1);
        line-height: 16px;
      }
    }
  }
}
</style>
<style lang="scss">
.common-upload {
  .el-upload-dragger {
    height: 105px;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
}
</style>

